// ERROR
export const SUPPORTED_ERRORS_CODES = [404, 500, 503];

// STORAGE
export const STORAGE_ACCESS_TOKEN = 'ACCESS_TOKEN';
export const STORAGE_VALID_TO = 'VALID_TO';
export const STORAGE_USER = 'USER';
export const STORAGE_USER_DOCUMENTATION_LANGUAGE = 'USER_DOCUMENTATION_LANGUAGE';
export const STORAGE_CHAT_USER = 'CHAT_USER';

// CREDIT
export const CREDIT_CONSTANT_C_HIGHER = 0.1095;
export const CREDIT_CONSTANT_C_LOWER = 0.069;

// Mask input
export const MASK_SWISS_PHONE_NUMBER = '__ ___ __ __';

// OTHER
export const NATIONALITY_PRIORITY_LIST = [
  "SWITZERLAND",
  "GERMANY",
  "AUSTRIA",
  "LIECHTENSTEIN",
  "FRANCE",
  "ITALY",
  "SERBIA",
  "PORTUGAL",
  "SPAIN",
  "TURKEY"
];

// IDnow supported nationalities for online authentication (Bank Now)
export const IDNOW_SUPPORTED_NATIONALITIES = [
  "GERMANY", "AFGHANISTAN", "EGYPT", "ALBANIA", "ALGERIA", "ANDORRA", "ANGOLA",
  "ARGENTINA", "AZERBAIJAN", "AUSTRALIA", "BAHRAIN", "BANGLADESH", "BARBADOS",
  "BELGIUM", "BENIN", "BOLIVIA", "BOSNIA_HERZEGOVINA", "BRAZIL", "BULGARIA",
  "BURKINA_FASO", "CHILE", "CHINA", "COSTA_RICA", "COTE_D_IVOIRE", "DENMARK",
  "DOMINICAN_REPUBLIC", "ECUADOR", "EL_SALVADOR", "ERITREA", "ESTONIA",
  "FINLAND", "FRANCE", "GEORGIA", "GHANA", "GREECE", "HONDURAS", "INDIA",
  "INDONESIA", "IRELAND", "ICELAND", "ISRAEL", "ITALY", "JAMAICA", "JAPAN",
  "YEMEN", "JORDAN", "CAMEROON", "CANADA", "KAZAKHSTAN", "KENYA", "COLOMBIA",
  "KOREA_REPUBLIC", "KOSOVO", "CROATIA", "CUBA", "KUWAIT", "LATVIA", "LEBANON",
  "LIECHTENSTEIN", "LITHUANIA", "LUXEMBOURG", "MALAWI", "MALAYSIA", "MALI",
  "MALTA", "MOROCCO", "NORTH_MACEDONIA", "NAMIBIA", "NEW_ZEALAND", "NETHERLANDS",
  "NIGERIA", "NORWAY", "OMAN", "AUSTRIA", "PERU", "POLAND", "PORTUGAL",
  "SAN_MARINO", "SWEDEN", "SWITZERLAND", "SENEGAL", "SERBIA", "SINGAPORE",
  "SLOVAKIA", "SLOVENIA", "SPAIN", "THAILAND", "CZECH_REPUBLIC", "TURKEY",
  "UGANDA", "UKRAINE", "HUNGARY", "VENEZUELA", "UNITED_KINGDOM", "VIETNAM",
  "BELARUS", "CYPRUS"
];
